import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/MemberCard.css';

function MemberCard({ id, profilePic, name, position, specializations, profileUrl }) {

    const handleError = (event) => {
        event.target.src = '/default_pfp.png';
    };

    return (
        <div className="member-card">
            {profileUrl ? (
                // Si `profileUrl` está presente, es un enlace externo
                <a href={profileUrl} target="_blank" rel="noopener noreferrer">
                    <img 
                        src={profilePic} 
                        alt={`${name}'s profile`} 
                        className="member-photo" 
                        onError={handleError}
                    />
                    <h3 className="member-name">{name}</h3>
                </a>
            ) : (
                // Si `profileUrl` está vacío, es un enlace interno a la `MemberPage`
                <Link to={`/members/${id}`}>
                    <img 
                        src={profilePic} 
                        alt={`${name}'s profile`} 
                        className="member-photo" 
                        onError={handleError}
                    />
                    <h3 className="member-name">{name}</h3>
                </Link>
            )}
            <h4 className="member-position">{position}</h4>
            <div className="member-divider"></div> {/* Line element */}
            <ul className="member-specializations">
                {specializations.map((spec, index) => (
                    <li key={index}>{spec}</li>
                ))}
            </ul>
        </div>
    );
}

export default MemberCard;
